export function initAdminCharts() {
    initAdminGigachatChart();
    initAdminRegistrationsChart();
    initSeoMetrikaProgressChart();
}

function initAdminGigachatChart() {
    var el = document.getElementById('admin-gigachat-chart');
    if (!el || typeof ApexCharts === 'undefined') return;
    var raw = el.dataset.chartData;
    if (!raw) return;
    var chartData;
    try { chartData = JSON.parse(raw); } catch (_) { return; }
    var categories = chartData.map(function(r) { return r.day; });
    var series = chartData.map(function(r) { return r.tokens; });
    if (categories.length === 0) { el.innerHTML = '<p class="text-slate-500 text-sm py-8">Нет данных за период</p>'; return; }
    new ApexCharts(el, {
        chart: { type: 'bar', height: 280, toolbar: { show: false }, fontFamily: 'Inter, system-ui, sans-serif' },
        plotOptions: { bar: { borderRadius: 4, columnWidth: '60%' } },
        dataLabels: { enabled: false },
        xaxis: { categories: categories, labels: { style: { fontSize: '11px' } } },
        yaxis: { labels: { style: { fontSize: '11px' } }, min: 0, tickAmount: 5 },
        colors: ['#0f172a'],
        grid: { borderColor: '#e2e8f0', strokeDashArray: 4, xaxis: { lines: { show: false } } },
        tooltip: { theme: 'light' },
        series: [{ name: 'Токенов', data: series }]
    }).render();
}

function initSeoMetrikaProgressChart() {
    var el = document.getElementById('seo-metrika-progress-chart');
    if (!el || typeof ApexCharts === 'undefined') return;
    var raw = el.dataset.chartData;
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw); } catch (_) { return; }
    if (!Array.isArray(data) || data.length === 0) return;
    var categories = data.map(function (r) { return r.month; });
    var visits = data.map(function (r) { return r.visits || 0; });
    new ApexCharts(el, {
        chart: { type: 'area', height: 220, toolbar: { show: false }, fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 2.5 },
        xaxis: { categories: categories, labels: { style: { fontSize: '11px', colors: '#64748b' } } },
        yaxis: { labels: { style: { fontSize: '11px', colors: '#64748b' } }, min: 0 },
        grid: { borderColor: '#e5e7eb', strokeDashArray: 4, yaxis: { lines: { show: true } }, xaxis: { lines: { show: false } } },
        tooltip: { theme: 'light', y: { formatter: function (val) { return (val || 0).toLocaleString('ru-RU') + ' визитов'; } } },
        colors: ['#2563eb'],
        fill: { type: 'gradient', gradient: { shadeIntensity: 0.25, opacityFrom: 0.7, opacityTo: 0.08, stops: [0, 80, 100], gradientToColors: ['#93c5fd'] } },
        series: [{ name: 'SEO\u2011визиты', data: visits }]
    }).render();
}

function initAdminRegistrationsChart() {
    var el = document.getElementById('admin-chart-registrations');
    if (!el || typeof ApexCharts === 'undefined') return;
    var raw = el.dataset.chartData;
    if (!raw) return;
    var chartData;
    try { chartData = JSON.parse(raw); } catch (_) { return; }
    var categories = chartData.map(function(r) { return r.day; });
    var series = chartData.map(function(r) { return r.count; });
    if (categories.length === 0) { el.innerHTML = '<p class="text-slate-500 text-sm py-8">Нет данных за период</p>'; return; }
    new ApexCharts(el, {
        chart: { type: 'bar', height: 280, toolbar: { show: false }, fontFamily: 'Inter, system-ui, sans-serif' },
        plotOptions: { bar: { borderRadius: 4, columnWidth: '60%' } },
        dataLabels: { enabled: false },
        xaxis: { categories: categories, labels: { style: { fontSize: '11px' } } },
        yaxis: { labels: { style: { fontSize: '11px' } }, min: 0, tickAmount: 5 },
        colors: ['#0f172a'],
        grid: { borderColor: '#e2e8f0', strokeDashArray: 4, xaxis: { lines: { show: false } } },
        tooltip: { theme: 'light' },
        series: [{ name: 'Регистраций', data: series }]
    }).render();
}
